// @flow
import xws from 'api/xws/';
import qs from 'query-string';

// Constants
import { getService } from 'constants/ajax';

export default function loginWS(data: {|
  tokenId: string,
  webKey: string,
  userName: string,
  password: string,
  locale: string
|}): Promise<any> {
  const loginService = getService('login');
  return xws(loginService).post(loginService.getPath(), qs.stringify(data));
}



// WEBPACK FOOTER //
// ./src/api/xws/login/loginWs.js